// src/App.tsx
import { Outlet, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Footer from "./components/Footer";
import Header from "./components/Header";
import MobileMenu from "./components/MobileMenu";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";

// Navigációnál automatikusan scroll to top
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const App = () => {
  // ✅ Fix iOS Safari 100vh (mobil böngésző sávok ne takarjanak ki)
  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setViewportHeight();
    window.addEventListener("resize", setViewportHeight);
    return () => window.removeEventListener("resize", setViewportHeight);
  }, []);

  return (
    <HelmetProvider>
      <ScrollToTop />
      <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
      <Header />

      <main
        style={{
          minHeight: "calc(var(--vh, 1vh) * 100)",
          backgroundColor: "black",
        }}
      >
        <Outlet />
      </main>

      <MobileMenu />
      <Footer />
    </HelmetProvider>
  );
};

export default App;

